"use client";

import { useLanguage } from '@/context/LanguageContext'
import { Container } from '@/components/common/Container'
import { FadeIn, FadeInStagger } from '@/components/FadeIn'

const texts = {
    en: {
        title: 'Web Artisan: Code, Design & Cloud',
        subTitle: 'Your digital partner',
        description: 'From the power of Laravel to scalable cloud solutions – I turn ideas into online reality.',
    },
    it: {
        title: 'Artigiano del Web: Codice, Design & Cloud',
        subTitle: 'Il tuo partner digitale.',
        description: 'Dalla potenza di Laravel a soluzioni cloud scalabili – trasformo idee in realtà online.',
    },
};

export function Header() {
    const { language } = useLanguage();
    return (
        <Container className="mt-24 sm:mt-32 md:mt-56">
            <FadeIn className="max-w-3xl">
                <h1 className="font-display text-5xl font-medium tracking-tight [text-wrap:balance] text-neutral-950 sm:text-7xl">
                    { texts[language as keyof typeof texts]?.title || texts['en'].title }
                    <br />
                    { texts[language as keyof typeof texts]?.subTitle || texts['en'].subTitle }
                </h1>
                <p className="mt-6 text-xl text-neutral-600">
                    { texts[language as keyof typeof texts]?.description || texts['en'].description }
                </p>
            </FadeIn>
        </Container>
    )
}
